import React, { useState } from 'react';

const PaymentModal = ({ isOpen, onClose, provider }) => {
  const [formData, setFormData] = useState({
    amount: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    description: 'Support for E-Gitsawe & Sinksar Ministry'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [paymentInstructions, setPaymentInstructions] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/payment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          provider,
          ...formData
        })
      });

      const result = await response.json();

      if (result.success) {
        if (result.checkout_url) {
          // Chapa or Telebirr H5 - redirect to checkout
          window.open(result.checkout_url, '_blank');
          onClose();
        } else if (result.instructions) {
          // Telebirr manual - show instructions
          setPaymentInstructions(result.instructions);
        }
      } else {
        setError(result.message || 'Payment initialization failed');
      }
    } catch (error) {
      console.error('Payment error:', error);
      setError('Failed to process payment. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal">
        <div className="payment-modal-header">
          <h2>
            {provider === 'chapa' ? '💳 Chapa Payment' : '📱 Telebirr Payment'}
          </h2>
          <button onClick={onClose} className="close-btn">✕</button>
        </div>

        {paymentInstructions ? (
          <div className="payment-instructions">
            <h3>📋 Payment Instructions</h3>
            <div className="instruction-details">
              <p><strong>Amount:</strong> {paymentInstructions.amount} ETB</p>
              <p><strong>Send to:</strong> {paymentInstructions.phone}</p>
              <p><strong>Reference:</strong> {paymentInstructions.reference}</p>
            </div>
            
            <div className="instruction-steps">
              <h4>Steps to complete payment:</h4>
              <ol>
                {paymentInstructions.steps.map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ol>
            </div>

            <div className="instruction-actions">
              <button onClick={onClose} className="btn-secondary">
                Close
              </button>
              <button 
                onClick={() => {
                  navigator.clipboard.writeText(paymentInstructions.phone);
                  alert('Phone number copied to clipboard!');
                }}
                className="btn-primary"
              >
                Copy Phone Number
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="payment-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">First Name *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number *</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="+251..."
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="amount">Amount (ETB) *</label>
              <input
                type="number"
                id="amount"
                name="amount"
                value={formData.amount}
                onChange={handleInputChange}
                min="10"
                step="0.01"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">Description (Optional)</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows="3"
              />
            </div>

            {error && (
              <div className="error-message">
                ❌ {error}
              </div>
            )}

            <div className="form-actions">
              <button type="button" onClick={onClose} className="btn-secondary">
                Cancel
              </button>
              <button type="submit" disabled={loading} className="btn-primary">
                {loading ? 'Processing...' : `Pay with ${provider === 'chapa' ? 'Chapa' : 'Telebirr'}`}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;